export default {
    "newpassword": "Enter new password",
    "repeatpwd": "Re-Enter new password",
    "oldpassword": "Enter current password",
    "wrongpassword": "Old password entered incorrectly",
    "samepassword": "New password can not be the same as old password",
    "successpassword": "Success, you will be redirected...",
    "NoEmailExist": "The Email is not registered",
    "Back": "Return"
}